import React from 'react'
import { MenuItem, Paper, Select, Typography } from '@mui/material'
import type { ClassicLeague } from 'types/fpl/leagues'

interface LeagueSelectProps {
  leagues: ClassicLeague[]
  selectedLeague: ClassicLeague | null
  setSelectedLeague: (league: ClassicLeague | null) => void
  isMobile: boolean
}

const LeagueSelect: React.FC<LeagueSelectProps> = ({
  leagues,
  selectedLeague,
  setSelectedLeague,
  isMobile,
}) => {
  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      <Typography
        variant='subtitle1'
        fontFamily='PremierLeagueBold'
        sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, mb: 1 }}
      >
        Leagues
      </Typography>
      <Select
        value={selectedLeague?.id ?? ''}
        onChange={(e): void => {
          const id: number = Number(e.target.value)
          const league: ClassicLeague | null = leagues.find((l): boolean => l.id === id) ?? null
          setSelectedLeague(league)
        }}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        sx={{
          '& .MuiSelect-select': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        }}
      >
        {leagues.map(league => (
          <MenuItem key={league.id} value={league.id}>
            <Typography
              fontFamily='PremierLeagueRegular'
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              {league.name}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Paper>
  )
}

export default LeagueSelect
